/** @format */

import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import MainLoading from "./components/loading/mainLoading";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Suspense fallback={<MainLoading />}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Suspense>
);
